import { render, staticRenderFns } from "./LeftBottom.vue?vue&type=template&id=c9faccd0&"
import script from "./LeftBottom.vue?vue&type=script&lang=js&"
export * from "./LeftBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports